import { cn } from "@/lib/utils";

interface StatusIndicatorProps {
  status: "OPTIMAL" | "GOOD" | "FAIR";
  size?: "sm" | "md" | "lg";
}

const statusConfig = {
  OPTIMAL: {
    color: "#10b981",
    position: 2 // rightmost square
  },
  GOOD: {
    color: "#eab308", // yellow
    position: 1 // middle square
  },
  FAIR: {
    color: "#ef4444", // red
    position: 0 // leftmost square
  }
} as const;

export function StatusIndicator({ status, size = "md" }: StatusIndicatorProps) {
  const squares = 3;
  const { color, position } = statusConfig[status];
  
  const sizeClasses = {
    sm: "h-1 w-3",
    md: "h-1.5 w-4",
    lg: "h-1.5 w-5"
  };

  return (
    <div className="flex flex-col items-end gap-1">
      <span className="text-xs text-[#f4f4f4]/80">
        {status}
      </span>
      <div className="flex gap-1">
        {Array.from({ length: squares }).map((_, i) => (
          <div
            key={i}
            className={cn(
              sizeClasses[size],
              "transition-colors rounded-[0.5px]"
            )}
            style={{
              backgroundColor: i === position ? color : 'rgba(244, 244, 244, 0.2)'
            }}
          />
        ))}
      </div>
    </div>
  );
} 